import { ReactElement } from 'react';
import { useRouteError } from 'react-router';
import { ErrorFallbackPage } from '../../components/errorFallback';
import frontendLog from '../frontendLog';

/**
 * Route-level error boundary for the data router. Any uncaught throw in a routed
 * element (including ad components, which can throw synchronously from third-party
 * tags) surfaces here instead of React Router's raw "Unexpected Application Error!"
 * default, so a single failing component can never white-screen the whole SPA.
 */
export function RouteErrorBoundary(): ReactElement {
  const err = useRouteError();
  frontendLog.error({ err }, 'RouteErrorBoundary caught a routing error');
  return <ErrorFallbackPage />;
}
